import type { CSSProperties, ReactNode } from 'react';
import { CIBLE_MIN, COULEURS, POLICE_SYSTEME } from '../../app/styles.js';
import type { EtatRequete } from '../../api/requete.js';

/** Corps de texte des espaces externes : 18 px (UX-20), police système, aucune police chargée. */
export const styleEspace: CSSProperties = { fontFamily: POLICE_SYSTEME, fontSize: 18, lineHeight: 1.5, color: COULEURS.marineFonce };
export const styleSection: CSSProperties = { marginBlock: 24 };
export const styleTitre: CSSProperties = { color: COULEURS.marine, fontSize: 28 };
export const styleSecondaire: CSSProperties = { color: COULEURS.ardoise };
export const styleLigne: CSSProperties = { display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: 8, paddingBlock: 8 };
export const styleAction: CSSProperties = {
  minHeight: CIBLE_MIN,
  minWidth: CIBLE_MIN,
  padding: '0 16px',
  borderRadius: 8,
  border: `1px solid ${COULEURS.marine}`,
  background: COULEURS.blanc,
  color: COULEURS.marine,
  font: 'inherit',
  cursor: 'pointer',
};

/** Coque commune : titre, étiquette de l’écran et états de lecture (chargement, vide, erreur). */
export function CoqueEspace<T>({
  ecran,
  titre,
  etat,
  vide,
  enfants,
}: {
  ecran: string;
  titre: string;
  etat: EtatRequete<T>;
  vide: string;
  enfants: (donnees: T) => ReactNode;
}) {
  return (
    <section data-ecran={ecran} style={styleEspace}>
      <h1 style={styleTitre}>{titre}</h1>
      {etat.etat === 'chargement' ? <p role="status">Chargement en cours…</p> : null}
      {etat.etat === 'vide' ? <p>{vide}</p> : null}
      {etat.etat === 'erreur' ? <p role="alert">{etat.message}</p> : null}
      {etat.etat === 'ok' ? enfants(etat.donnees) : null}
    </section>
  );
}
